__turbopack_context__.v({
  "blink": "Footer-module-scss-module__UYniKq__blink",
  "centered": "Footer-module-scss-module__UYniKq__centered",
  "centeredMobile": "Footer-module-scss-module__UYniKq__centeredMobile",
  "footer": "Footer-module-scss-module__UYniKq__footer",
  "lastColumn": "Footer-module-scss-module__UYniKq__lastColumn",
  "lastColumnMobile": "Footer-module-scss-module__UYniKq__lastColumnMobile",
  "logo": "Footer-module-scss-module__UYniKq__logo",
  "menus": "Footer-module-scss-module__UYniKq__menus",
  "newsletter": "Footer-module-scss-module__UYniKq__newsletter",
  "newsletterText": "Footer-module-scss-module__UYniKq__newsletterText",
});
